import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ObjectUnsubscribedError, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ContagemInventarioService {

  constructor(private http: HttpClient) { }

  public getAllInventario(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `ContagemInventario/Inventario?numero=${req.numero}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : '&paginaAtual=1'}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : '&paginaAtual=10'}`,        
        { observe: 'response' }
      );
  }
  
  public getAllItensInventariados(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `ContagemInventario/ItensInventariados?&numero=${req.numero}
        ${req.paginaAtual ?`&paginaAtual=${(req.paginaAtual || 0) + 1}`:'&paginaAtual=1'}
        ${req.itensPorPagina ?`&itensPorPagina=${req.itensPorPagina}` :'&paginaAtual=10'}`,
        { observe: 'response' }
      );
  }

  public getAllItensFaltas(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `ContagemInventario/ItensFalta?numero=${req.numero}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : '&paginaAtual=1'}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,        
        { observe: 'response' }
      );
  }

  public getAllItensSobra(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `ContagemInventario/ItensSobra?numero=${req.numero}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : '&paginaAtual=1'}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,        
        { observe: 'response' }
      );
  }

  public getAllDadosContagemItensFaltas(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `ContagemInventario/DadosItensFalta?numero=${req.numero}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : '&paginaAtual=1'}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,        
        { observe: 'response' }
      );
  }  

  public salvarJustificativaDadosItens(req: any): Observable<HttpResponse<any>> {
    console.log('----->', JSON.stringify(req));
    return this.http
      .put(
        `ContagemInventario`,
        req,
        { observe: 'response'}
      );
  }    

  public getAllDadosContagemItensSobra(req: any): Observable<HttpResponse<any[]>> {
    return this.http
      .get<any[]>(
        `ContagemInventario/DadosItensSobra?numero=${req.numero}
        ${req.paginaAtual ? `&paginaAtual=${(req.paginaAtual || 0) + 1}` : '&paginaAtual=1'}
        ${req.itensPorPagina ? `&itensPorPagina=${req.itensPorPagina}` : ''}`,        
        { observe: 'response' }
      );
  }  
    
}
